const carouselItems = [
  {
    id: 1,
    title: '暗夜追凶',
    subtitle: '全网热播悬疑大剧迎来大结局',
    desc: '妖精视频现象级悬疑剧《暗夜追凶》即将迎来大结局，真相即将揭晓。嫩草视频已同步收录全季高清资源，一集不落畅享完整追剧体验。',
    tag: '大结局',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20promotional%20poster%2C%20dark%20moody%20urban%20night%20scene%20with%20warm%20amber%20streetlights%2C%20mysterious%20silhouette%20in%20rainy%20alley%2C%20dramatic%20noir%20lighting%2C%20premium%20Chinese%20suspense%20series%20aesthetic%2C%20cinematic%20wide%20composition%2C%20high%20contrast%20atmospheric%20visual&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '长安秘事录',
    subtitle: '苹果视频古装探案新剧火爆出圈',
    desc: '唐风古韵邂逅悬疑探案，《长安秘事录》豆瓣开分 8.6，服化道精良、剧情烧脑，被誉为年度古装黑马。苹果视频独播，嫩草视频同步收录。',
    tag: '口碑好剧',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Tang%20dynasty%20palace%20interior%20with%20warm%20candlelight%20illumination%2C%20traditional%20Chinese%20architecture%20and%20flowing%20silk%20fabrics%2C%20golden%20amber%20and%20red%20color%20palette%2C%20mysterious%20historical%20detective%20atmosphere%2C%20premium%20costume%20drama%20cinematography%2C%20artistic%20period%20production%20design&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '山海异兽录',
    subtitle: '奇幻冒险巨制双平台联播',
    desc: '改编自经典古籍的视效大片《山海异兽录》在妖精视频和桃花视频同步热播，特效炸裂、世界观宏大，播放量已突破 10 亿大关。',
    tag: '视效大片',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20landscape%20with%20mythical%20creatures%20and%20floating%20mountains%2C%20dramatic%20golden%20sunset%20sky%2C%20magical%20glowing%20elements%2C%20cinematic%20wide%20hero%20shot%2C%20warm%20coral%20and%20amber%20atmospheric%20lighting%2C%20premium%20fantasy%20adventure%20visual%2C%20high%20production%20value%20concept%20art&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '夏季追剧日历',
    subtitle: '2026 暑期档热门剧集完整排播',
    desc: '整理妖精视频、桃花视频、苹果视频、榴莲视频等平台暑期档全部新剧上映时间，一图掌握追剧节奏，再也不用担心错过更新。',
    tag: '追剧攻略',
    img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20calendar%20and%20streaming%20interface%20on%20laptop%2C%20warm%20natural%20summer%20lighting%2C%20organized%20entertainment%20planning%20scene%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20premium%20lifestyle%20editorial%20photography%2C%20minimal%20comfortable%20workspace%20aesthetic&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-sparkling-line"></i>
            编辑精选
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            专题推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精心挑选的热门专题和追剧指南，不容错过的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group flex flex-col"
            >
              <div className="aspect-[16/9] bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-foreground-950 font-heading text-lg md:text-xl mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm mb-3">{item.subtitle}</p>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-3 mt-auto">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}